const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/", "/Salesforce"],
    exact: true,
    component: "Salesforce",
  },

];

export default routes;
